import React from 'react';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { Button, Container, Grid, Typography } from '@mui/material';
import Hello from './Hello.png';

export function GetStarted() {
  const { nextPane } = useAppStateContext();

  return (
    <Container>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={5}>
          <Typography variant="h5" gutterBottom>
            Let's get started.
          </Typography>

          <Typography variant="body1" gutterBottom>
            We'll help you solve any video troubles you're experiencing but first, let's check your
            setup.
          </Typography>

          <Button variant="contained" color="primary" onClick={nextPane}>
            Get started
          </Button>
        </Grid>
        {/* 
        <Grid item md={5}>
          <img src={Hello} alt="Hello" style={{ width: '284px', height: '284px' }} />
          <Typography variant="body1" color="textSecondary">
            <strong>Not sure about something?</strong> Skip that section for now, and your support
            administrator can help later.
          </Typography>
        </Grid> */}
      </Grid>
    </Container>
  );
}
